import React, { ReactNode } from 'react';
import dynamic from 'next/dynamic';

import { IFooterProps } from '../../components/footer/model';
import { INavProps } from '@mais-retorno-front/components/navbar/interface';

const Navbar = dynamic<INavProps>(() =>
  import('@mais-retorno-front/components/navbar').then((mod) => mod.Navbar)
);

const Footer = dynamic<IFooterProps>(() =>
  import('@mais-retorno-front/components/footer').then((mod) => mod.Footer)
);

interface IHomeLayoutProps {
  children: ReactNode;
  useH1?: boolean;
  termOfDay?: {
    excerpt: string;
    link: string;
    title: string;
    related_terms: {
      link: string;
      title: string;
    }[];
  };
  footer?: boolean;
}

export default function HomeLayout({
  children,
  termOfDay,
  useH1 = true,
  footer = true,
}: IHomeLayoutProps) {
  return (
    <>
      <Navbar useH1={useH1} />
      <main>{children}</main>
      {footer && <Footer termOfDay={termOfDay} />}
    </>
  );
}
